// CBT Exam Answers Reducer
// Manages exam answers state with Redux Persist

const initialState = {
  answers: {}, // Format: { [coursecode]: { [questionId]: answer } }
  examData: null, // Current exam data
  startTime: null, // Exam start time
  timeRemaining: {} // Format: { [coursecode]: timeRemainingInSeconds }
};

const CBTExamReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_CBT_ANSWER':
      // Save answer for a specific course and question
      const { coursecode, questionId, answer } = action.payload;
      return {
        ...state,
        answers: {
          ...state.answers,
          [coursecode]: {
            ...(state.answers[coursecode] || {}),
            [questionId]: answer
          }
        }
      };
    
    case 'LOAD_CBT_ANSWERS':
      // Load all answers for a specific course
      const { coursecode: loadCoursecode, answers: loadedAnswers } = action.payload;
      return {
        ...state,
        answers: {
          ...state.answers,
          [loadCoursecode]: loadedAnswers
        }
      };
    
    case 'INITIALIZE_CBT_ANSWERS':
      // Initialize answers for a course (set up empty answers for all questions)
      const { coursecode: initCoursecode, questionIds } = action.payload;
      
      // Get existing answers (from Redux Persist)
      const existingAnswers = state.answers[initCoursecode] || {};
      
      // Start with existing answers (preserve all saved answers)
      const mergedAnswers = { ...existingAnswers };
      
      // Only add empty strings for questions that don't have answers yet
      questionIds.forEach(id => {
        const idStr = String(id);
        const idNum = Number(id);
        // Check both string and number keys
        if (!mergedAnswers[idStr] && !mergedAnswers[idNum] && mergedAnswers[id] === undefined) {
          mergedAnswers[idStr] = '';
        }
      });
      
      console.log('🔄 INITIALIZE_CBT_ANSWERS:', {
        coursecode: initCoursecode,
        questionIds,
        existingAnswers,
        mergedAnswers
      });
      
      return {
        ...state,
        answers: {
          ...state.answers,
          [initCoursecode]: mergedAnswers
        }
      };
    
    case 'CLEAR_CBT_ANSWERS':
      // Clear answers and time remaining for a specific course
      const { coursecode: clearCoursecode } = action.payload;
      const newAnswers = { ...state.answers };
      const newTimeRemaining = { ...state.timeRemaining };
      delete newAnswers[clearCoursecode];
      delete newTimeRemaining[clearCoursecode];
      return {
        ...state,
        answers: newAnswers,
        timeRemaining: newTimeRemaining
      };
    
    case 'SET_CBT_EXAM_DATA':
      // Store current exam data
      return {
        ...state,
        examData: action.payload
      };
    
    case 'SET_CBT_START_TIME':
      // Store exam start time
      return {
        ...state,
        startTime: action.payload
      };
    
    case 'SET_CBT_TIME_REMAINING':
      // Store time remaining for a specific course
      const { coursecode: timeCoursecode, timeRemaining } = action.payload;
      return {
        ...state,
        timeRemaining: {
          ...state.timeRemaining,
          [timeCoursecode]: timeRemaining
        }
      };
    
    case 'CLEAR_ALL_CBT_DATA':
      // Clear all CBT exam data (for logout or reset)
      return initialState;
    
    default:
      return state;
  }
};

export default CBTExamReducer;

